import React, { useState, useEffect } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Checkbox from "@mui/material/Checkbox";
import {
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Button,
} from "@mui/material";
import "@fullcalendar/daygrid/main.css";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";
import EditWorkoutPopup from "src/pages/Calender/component/EditWorkoutPopup";
import { set_program_difficulty_level_api } from "src/DAL/programmeWorkout/programmeWorkout";
import { Icon } from "@iconify/react";
import { get_root_value } from "src/utils/domUtils";
import { s3baseUrl, harmonyRingEnabled } from "src/config/config";
import CustomPopoverNew from "../CustomPopoverNew";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { show_proper_words } from "src/utils/constants";
import Box from "@mui/material/Box";
import { gr } from "src/design-system/tokens";
import GrPage from "src/design-system/components/GrPage";
import { grScrollIntoView } from "src/design-system/components/GrCollapse";
import CalendarWorkoutCard, { CalendarCardsContext } from "./CalendarWorkoutCard";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

function GeneralCalendar({
  programWorkoutList,
  reorderedWorkoutList,
  setCurrentDate,
  time_zone,
  currentDate,
  isLoading,
  reloadList,
  calendar_title,
  hideArrowsAndButtons,
  programme,
  member_vdot,
  memberRewardData,
  setSubmitted,
  submitted,
  calendarRef,
  goToToday,
  levelStats,
  manualLoading,
  // Optional: a page's own top bar (programme calendar). Gets the same handlers the old
  // header rows use; without it the old header is drawn (main Calendar page).
  renderHeader,
}) {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const classes = useStyles();
  const params = useParams();
  const { userInfo } = useContentSetting();
  const { enqueueSnackbar } = useSnackbar();
  const [editItrationDrawerState, setEditItrationDrawerState] = useState();
  const [editWorkputData, setEditWorkputData] = useState();
  const [openLevels, setOpenLevels] = useState(false);
  const [difficultyLevel, setDifficultyLevel] = useState("");
  const [tempDifficultyLevel, setTempDifficultyLevel] = useState("");
  const [checked, setChecked] = useState(false);
  const globalOpenRef = React.useRef(true);
  // Cards own their open state (see CalendarWorkoutCard); these drive Expand / Collapse all.
  const [allOpen, setAllOpen] = useState({ open: true, version: 0 });
  const openByIdRef = React.useRef(new Map());

  const handleChangeCheck = (event) => {
    setChecked(event.target.checked);
  };

  const getWorkoutCountForLevel = () => {
    if (
      !tempDifficultyLevel ||
      !levelStats ||
      !Array.isArray(levelStats) ||
      levelStats.length === 0
    ) {
      return 0;
    }
    const levelStat = levelStats.find(
      (stat) => stat.difficulty_level === tempDifficultyLevel,
    );
    return levelStat ? levelStat.count : 0;
  };

  const handleAddLevels = async () => {
    if (!tempDifficultyLevel) {
      return enqueueSnackbar(`Please Select Levels`, { variant: "error" });
    }
    let postData = {
      program_id: programme?._id?._id || programme?.program_info?.program_id,
      member_id: userInfo?._id,
      difficulty_level: tempDifficultyLevel,
    };
    let result = await set_program_difficulty_level_api(postData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setDifficultyLevel(tempDifficultyLevel);
      setOpenLevels(false);
      reloadList();
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleOpenEditIterationDrawer = () => {
    setEditItrationDrawerState(true);
  };

  const handleUpdateIteration = (data) => {
    setEditWorkputData(data);
    handleOpenEditIterationDrawer();
  };

  // ── NEW: Expand / Collapse all handlers ──────────────────────────────────
  // Cards animate open / closed; the last opened card is then brought back into view smoothly.
  const setAllCards = (open) => {
    globalOpenRef.current = open;
    openByIdRef.current.clear();
    setAllOpen((was) => ({ open, version: was.version + 1 }));
    if (editWorkputData?._id) {
      setTimeout(() => {
        grScrollIntoView(
          document.querySelector(
            `.calendar-workout-card[id="${editWorkputData._id}"]`,
          ),
          "center",
        );
      }, 280);
    }
  };
  const handleExpandAll = () => setAllCards(true);
  const handleCollapseAll = () => setAllCards(false);
  // ─────────────────────────────────────────────────────────────────────────

  const renderEventContent = (eventInfo) => {
    return <CalendarWorkoutCard workout={eventInfo.event} />;
  };

  const getEventListing = async (workout) => {
    let all_events = [];
    if (workout.length > 0) {
      all_events = workout.map((workout, i) => {
        return {
          ...workout,
          title: workout.title ? workout.title : "",
          color: workout.program_info?.color,
          workout_color: workout.program_info?.color,
          workout_title: workout.title ? workout.title : "",
          workout_exercises: workout.exercises,
          workout_program: workout.program_info,
          status: workout.status,
          date: moment.utc(workout.workout_date).format("YYYY-MM-DD"),
          index: i,
          order: i,
          open: globalOpenRef.current,
          editable: false,
        };
      });
    }

    const eventsDict = {};
    all_events.forEach((event) => {
      eventsDict[event._id] = event;
    });

    const reorderedEvents = [];
    let remainingEvents = [...all_events];

    reorderedWorkoutList.forEach((workout) => {
      const { workout_date, reorder_workouts } = workout;
      reorder_workouts.forEach((workout_id, index) => {
        if (eventsDict[workout_id]) {
          const event = eventsDict[workout_id];
          event.order = index;
          reorderedEvents.push(event);
          const remainingIndex = remainingEvents.findIndex(
            (e) => e._id === workout_id,
          );
          if (remainingIndex > -1) {
            remainingEvents.splice(remainingIndex, 1);
          }
        }
      });
      const remainingSameDateEvents = remainingEvents.filter(
        (event) => event.workout_date === workout_date,
      );
      remainingSameDateEvents.forEach((event) => {
        reorderedEvents.push(event);
      });
      remainingEvents = remainingEvents.filter(
        (event) => event.workout_date !== workout_date,
      );
    });

    reorderedEvents.push(...remainingEvents);

    let all_reorder_events = reorderedEvents.map((workout, i) => {
      return {
        ...workout,
        title: workout.title ? workout.title : "",
        color: workout.program_info?.color,
        workout_color: workout.program_info?.color,
        workout_title: workout.title ? workout.title : "",
        workout_exercises: workout.exercises,
        workout_program: workout.program_info,
        status: workout.status,
        open: globalOpenRef.current,
        date: moment.utc(workout.workout_date).format("YYYY-MM-DD"),
        index: i,
        order: i,
        editable: false,
      };
    });

    setEvents(all_reorder_events);
  };

  const getCenteredText = () => {
    let text = moment(new Date()).format("MMM YYYY");
    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();
      const currentMonth = calendarApi.getDate().getMonth();
      const currentYear = calendarApi.getDate().getFullYear();
      text = moment().month(currentMonth).format("MMM") + " " + currentYear;
    }
    return text;
  };

  const hanldeChangeDates = (value) => {
    let start_date = currentDate.start_date;
    let end_date = currentDate.end_date;
    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();
      const currentView = calendarApi.view;
      const startDate = currentView.activeStart;
      const endDate = currentView.activeEnd;
      start_date = startDate;
      end_date = endDate;
    }
    let new_object = {};
    if (value == "next") {
      new_object = {
        start_date: moment(start_date),
        end_date: moment(end_date),
      };
    } else {
      new_object = {
        start_date: moment(start_date),
        end_date: moment(end_date),
      };
    }
    setCurrentDate(new_object);
  };

  const handleChangeNextPrev = (value) => {
    let classToClick = "fc-next-button";
    if (value == "prev") {
      classToClick = "fc-prev-button";
    }
    let click_element = document.getElementsByClassName(classToClick)[0];
    click_element.click();
    hanldeChangeDates(value);
  };

  const handleClickDate = (workout) => {
    setCurrentDate({
      start_date: workout.dateStr,
      end_date: workout.dateStr,
    });
  };

  const todayNumberSx = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: gr.control.sm,
    height: gr.control.sm,
    px: gr.space[1],
    borderRadius: gr.radius.pill,
    background: gr.color.brandStrong,
    color: gr.color.onBrand,
  };

  const renderDayCell = (arg) => {
    return (
      <div
        style={{
          position: "relative",
          height: "100%",
          marginTop: -10,
        }}
      >
        {/* Today: the date in a filled teal circle, so the member sees at once which day is today. */}
        <Box component="span" sx={arg?.isToday ? todayNumberSx : undefined}>
          {arg?.dayNumberText}
        </Box>{" "}
        <span className="day-cell-name" style={{ opacity: 0.5, fontSize: 10 }}>
          {moment(arg?.date).format("ddd")}
        </span>
      </div>
    );
  };

  const handleViewGraph = (value) => {
    navigate(`/programmes/calendar/${params.slug}/${value._id}`);
  };

  useEffect(() => {
    if (
      !programme?.member_difficutly_level &&
      programme?._id?.difficulty_level
    ) {
      setOpenLevels(true);
    }
  }, [programme?.member_difficutly_level]);

  useEffect(() => {
    if (!!programme?.open_dashboard) {
      setEditWorkputData({
        ...programme,
        ...programme.program_info,
      });
      handleOpenEditIterationDrawer();
    }
  }, [programme?.open_dashboard]);

  useEffect(() => {
    let start_date = currentDate.start_date;
    let end_date = currentDate.end_date;
    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();
      const currentView = calendarApi.view;
      const startDate = currentView.activeStart;
      const endDate = currentView.activeEnd;
      start_date = startDate;
      end_date = endDate;
    }
  }, [calendarRef]);

  useEffect(() => {
    getEventListing(programWorkoutList, time_zone);
  }, [programWorkoutList, submitted]);

  useEffect(() => {
    if (programme?.member_difficutly_level) {
      setDifficultyLevel(programme?.member_difficutly_level);
      setTempDifficultyLevel(programme?.member_difficutly_level);
    }
  }, [programme?.member_difficutly_level]);

  useEffect(() => {
    if (editWorkputData?._id) {
      setTimeout(() => {
        const todayCell = document.querySelector(
          `.calendar-workout-card[id="${editWorkputData?._id}"]`,
        );
        if (todayCell) {
          grScrollIntoView(todayCell, "center");
        }
      }, 0);
    }
  }, [events, editWorkputData]);

  const eventOrderFunction = (a, b) => {
    return a.order - b.order;
  };

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  const backFromCalendar = () => {
    navigate(-1);
    localStorage.removeItem("difficultyLevel");
    localStorage.removeItem("isOpen");
  };
  // With a page header the box lines up with the top bar (GrPage) and the bootstrap row margins go.
  const PageBox = renderHeader ? GrPage : "div";

  return (
    <PageBox className={renderHeader ? undefined : "container-fluid"}>
      {renderHeader ? (
        renderHeader({
          title: calendar_title,
          level: difficultyLevel ? show_proper_words(difficultyLevel) : "",
          onBack: backFromCalendar,
          onCompliance: programme?._id?.is_harmony_ring_enabled
            ? () => handleViewGraph(programme?._id)
            : null,
          monthLabel: getCenteredText(),
          onPrev: () => handleChangeNextPrev("prev"),
          onNext: () => handleChangeNextPrev("next"),
          loading: Boolean(manualLoading),
          showArrows: !hideArrowsAndButtons,
          canExpand: events.length > 0,
          onExpandAll: handleExpandAll,
          onCollapseAll: handleCollapseAll,
          onToday: () => goToToday(),
        })
      ) : (
      <div className="row">
        <div className="col-md-9 col-12 d-flex align-items-center">
          <IconButton
            className="back-screen-button mb-0 me-2"
            onClick={() => {
              navigate(-1);
              localStorage.removeItem("difficultyLevel");
              localStorage.removeItem("isOpen");
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <div>
            <h2 className="font-size-on-sm">{calendar_title}</h2>
            {difficultyLevel && (
              <p className="mb-2 text-muted">
                Difficulty Level : {show_proper_words(difficultyLevel)}
              </p>
            )}
          </div>
        </div>

        {harmonyRingEnabled && programme?._id?.is_harmony_ring_enabled && (
          <div className="col-md-3 col-12 text-end">
            <Button
              variant="contained"
              onClick={() => {
                handleViewGraph(programme?._id);
              }}
            >
              My Compliance
            </Button>
          </div>
        )}

        {/* Row 2: Prev/Next | Month Title | Expand/Collapse/Today */}
        <div className="col-12 mt-2">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

            {/* Prev / Next arrows */}
            <div className="d-flex align-items-center gap-2">
              {!hideArrowsAndButtons && (
                <>
                  <div className="btn-group toollbar-group-buttons group-buttons-font-size-on-sm">
                    <button
                      className="small-contained-button"
                      onClick={() => handleChangeNextPrev("prev")}
                    >
                      <ArrowBackIosIcon />
                    </button>
                    <button
                      className="small-contained-button"
                      onClick={() => handleChangeNextPrev("next")}
                    >
                      <ArrowForwardIosIcon />
                    </button>
                  </div>
                  {manualLoading && (
                    <CircularProgress
                      size={20}
                      style={{ verticalAlign: "middle" }}
                    />
                  )}
                </>
              )}
            </div>

            {/* Month / Year label — centered */}
            <h3
              className="font-size-on-sm mb-0 flex-grow-1 text-center"
              style={{ color: "#04abbb" }}
            >
              {getCenteredText()}
            </h3>

            {/* Expand All / Collapse All / Today */}
            <div className="d-flex align-items-center flex-wrap gap-1">
              {events.length > 0 && (
                <>
                  <Button
                    size="small"
                    onClick={handleExpandAll}
                    startIcon={<KeyboardArrowDownIcon />}
                    sx={{
                      bgcolor: "grey.700",
                      color: "#fff",
                      borderRadius: "8px",
                      px: 1,
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                      py: 0.5,
                      minWidth: 0,
                      "&:hover": { bgcolor: "grey.900" },
                    }}
                  >
                    Expand All
                  </Button>

                  <Button
                    size="small"
                    onClick={handleCollapseAll}
                    startIcon={<KeyboardArrowUpIcon />}
                    sx={{
                      bgcolor: "grey.700",
                      color: "#fff",
                      borderRadius: "8px",
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                      px: 1,
                      py: 0.5,
                      minWidth: 0,
                      "&:hover": { bgcolor: "grey.900" },
                    }}
                  >
                    Collapse All
                  </Button>
                </>
              )}
              <div className="group-buttons-font-size-on-sm">
                <button
                  className="small-contained-outlined-button"
                  onClick={() => goToToday()}
                >
                  Today
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
      )}

      <div className={renderHeader ? undefined : "row"}>
        <Box
          className="full-calendar full-calendar-new-flow mt-3"
          // Today's box in the brand tint (FullCalendar's default is pale yellow), with a teal line on top.
          sx={{
            "--fc-today-bg-color": gr.color.brandSoft,
            "& .fc-daygrid-day.fc-day-today": {
              boxShadow: `inset 0 2px 0 ${gr.color.brand}`,
            },
          }}
        >
          <CalendarCardsContext.Provider
            value={{
              selectedId: editWorkputData?._id,
              onOpenWorkout: handleUpdateIteration,
              allOpen,
              openById: openByIdRef.current,
            }}
          >
            <FullCalendar
              ref={calendarRef}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: "today prev,next",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay",
              }}
              className="fc-day-sun fc-toolbar-chunk fc eventimage fc-col-header-cell-cushion fc-today-button fc-right fc-prev-button fc-right fc-next-button fc-dayGridMonth-button fc-timeGridWeek-button fc-timeGridDay-button fc-daygrid-day-number fc-daygrid-day-top"
              eventContent={renderEventContent}
              events={events}
              initialView="dayGridMonth"
              dayCellContent={renderDayCell}
              editable={true}
              selectable={true}
              selectMirror={true}
              eventOrder={eventOrderFunction}
              weekends={true}
              fixedWeekCount={false}
              height="auto"
              stickyHeaderDates={false}
              moreLinkContent={function (args) {
                return "+" + args.num;
              }}
              moreLinkClick={function (args) {
                handleClickDate(args);
              }}
            />
          </CalendarCardsContext.Provider>
        </Box>
      </div>

      <EditWorkoutPopup
        open={editItrationDrawerState}
        setOpen={setEditItrationDrawerState}
        programme={programme}
        data={editWorkputData}
        reloadList={reloadList}
        member_vdot={member_vdot}
        memberRewardData={memberRewardData}
        setEvents={setEvents}
        setEditWorkputData={setEditWorkputData}
        events={events}
        setSubmitted={setSubmitted}
      />

      <CustomPopoverNew
        is_hide_icon={programme?.member_difficutly_level ? false : true}
        width="550px"
        isOpenPop={openLevels}
        isClosePop={() => {
          setOpenLevels(false);
          setTempDifficultyLevel("");
        }}
        title={"Difficulty Levels"}
        componentToPassDown={
          <div className="px-4 pb-3">
            <FormControl fullWidth sx={{ mb: 2, mt: 2 }} required>
              <InputLabel id="demo-simple-select-label">
                Difficulty Levels
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="difficulty_levels"
                value={tempDifficultyLevel}
                label="Difficulty Levels"
                onChange={(e) => {
                  setTempDifficultyLevel(e.target.value);
                }}
              >
                <MenuItem value="novice">Novice</MenuItem>
                <MenuItem value="intermediate">Intermediate</MenuItem>
                <MenuItem value="advanced">Advanced</MenuItem>
              </Select>
            </FormControl>

            {tempDifficultyLevel && (
              <div
                style={{
                  backgroundColor: "#f5f5f5",
                  padding: "12px",
                  borderRadius: "8px",
                  marginBottom: "16px",
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#333",
                }}
              >
                You will have <strong>{getWorkoutCountForLevel()}</strong>{" "}
                workouts with{" "}
                <strong>{show_proper_words(tempDifficultyLevel)}</strong>{" "}
                difficulty
              </div>
            )}

            <div className="mb-2" style={{ width: "500px", maxWidth: "100%" }}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox checked={checked} onChange={handleChangeCheck} />
                  }
                  label="Workouts with your selected difficulty level will be assigned to you for this programme. (To change it, please submit a support ticket.)"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      color: "gray",
                      fontSize: "14px",
                    },
                  }}
                />
              </FormGroup>
            </div>

            <div className="text-end">
              <Button
                variant="contained"
                disabled={!checked}
                onClick={handleAddLevels}
              >
                Save
              </Button>
            </div>
          </div>
        }
      />
    </PageBox>
  );
}

export default GeneralCalendar;
